import React, { useEffect } from "react";
import QrNotificationsWatcher from "./QrNotificationsWatcher";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import useSessionAuth from "src/hooks/useSessionAuth";
import { useDispatch, useSelector } from "src/redux/store";
import LoadingScreen from "src/components/LoadingScreen";
import { getUser } from "src/redux/slices/user";
import { useNotificationSessionHub } from "src/utils/hubs/NotificationHub";
import useHubSessions from "src/utils/hubs/hubSessions";
import {
  useProductSessionHub,
  useProductUserHub,
} from "src/utils/hubs/HubProductoSession";
import useBackgroundSyncDetectSession from "../DashboardLayout/UseBackgroundSyncDetectSessions";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

HomeLayout.propTypes = {
  children: PropTypes.node,
};

function HomeLayout({ children }) {
  useBackgroundSyncDetectSession();

  useNotificationSessionHub();
  useHubSessions();
  useProductUserHub();
  useProductSessionHub();

  const { isSessionAuthenticated, session } = useSessionAuth();
  const { user } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isSessionAuthenticated) dispatch(getUser(session.idRestaurante));
  }, []);

  const useStyles = makeStyles((theme) => ({
    root: {
      height: "100%",
    },
    content: {
      height: "100%",
    },
  }));

  const classes = useStyles();

  if (isSessionAuthenticated && !user) return <LoadingScreen />;

  // 2026-09-27 · TopBar visual eliminado (feedback user: "quitar el
  // topbar, muy anticuado"). Antes montaba un AppBar con Logo +
  // Languages + Notifications ocupando 64/92px + un modal DialogAnimate
  // para "pedidos listos". Ahora el modal + snackbar se disparan desde
  // `QrNotificationsWatcher` (invisible, monta solo la lógica) y las
  // vistas QR ganan esos 64/92px de viewport útil.
  return (
    <div className={classes.root}>
      {isSessionAuthenticated && <QrNotificationsWatcher />}
      <div className={classes.content}>{children}</div>
    </div>
  );
}

export default HomeLayout;
